// extracted by mini-css-extract-plugin
export default {"container":"Dj-z","blurb":"Ej-z","links":"Fj-z"};